module.exports = __webpack_public_path__ + "static/media/ejemplo_aporte_requerido.f15a13ea.png";